import AppConfig from "AppConfig";

export default function (keyName) {
   let suffix = "wort";
   if(window.location.host.indexOf("luxtimes.lu") !== -1) {
        suffix = "luxtimes";
   }

   let identityKey = `${keyName}_${suffix}`;

   return AppConfig[identityKey];
}



// WEBPACK FOOTER //
// ./js/utils/IdentityConfig.js